import React from 'react';
import { connect } from 'react-redux';
import Box from '../profilePage/components/Box';
import BoxesRow from '../profilePage/components/BoxesRow';
import ActionButton from '../../components/ActionButton';
import LoadingPanel from 'routes/components/LoadingPanel';
import { customer } from '../../../modules';
import { hardwareProducts } from '../../../modules/customer/profile'
import { push } from 'connected-react-router';

class UpdateCustomer extends React.Component {

    editableProperties = [
        { "Name": "externalReference", "Label": "Partner kundenummer" },
        //{ "Name": "mobilePhone", "Label": "Mobile" },
        //{ "Name": "email", "Label": "Email" }
        ];

    isWorking = () => this.props.isLoading || this.props.isSaving;

    getUpdateFormProperty = (name, label, value) =>
        <div className="col-xs-12" key={"updateForm" + name}>
            {label}: <input
                className="input col-xs-12"
                type="text"
                placeholder={label}
                defaultValue={value}
                onChange={(e) => this.props.setCustomerProperty(name, e.target.value)}
            />
        </div>

    getForm = (properties, customer) => properties.map(property => this.getUpdateFormProperty(property.Name, property.Label, customer[property.Name]));

    render = () =>
        <div className="col-xs-12">
            {this.isWorking() ? <LoadingPanel /> : this.getForm(this.editableProperties, this.props.customer)}
        </div>

}

const mapStateToProps = (state, props) => ({
    //customerId: customer.profile.selectors.getCustomerID(state),
    customer: customer.profile.selectors.getCustomerDetails(state),
    isLoading: customer.profile.selectors.isLoading(state),
    isSaving: customer.profile.selectors.isLoading(state),
    data: customer.profile.selectors.getUpdateForm(state),
});

const mapDispatchToProps = (dispatch, props) => ({    
    //loadCustomer: (id) => dispatch(customer.profile.actions.fetchCustomer(id)),
    setCustomerProperty: (propertyName, value) => dispatch(customer.profile.actions.setCustomerProperty(propertyName, value)),        
});

export default connect(mapStateToProps, mapDispatchToProps)(UpdateCustomer);